export default {
  insertionOrders: state => {
    return state.insertionOrders
  },
  folders: state => {
    return state.folders
  },
  creatives: state => {
    return state.creatives
  },
  currentResource: state => {
    return state.currentResource
  },
  currentFolder: state => {
    return state.currentFolder
  },
  currentCreative: state => {
    return state.currentCreative
  },
  loading: state => {
    return state.loading
  },
  selectedCreatives: state => {
    return state.selectedCreatives
  },
  selectedCreativeTypes: state => {
    return state.selectedCreativeTypes
  },
  selectedAuditStatuses: state => {
    return state.selectedAuditStatuses
  },
  searchKeyword: state => {
    return state.searchKeyword
  },
  pageNo: state => {
    return state.pageNo
  },
  pageSize: state => {
    return state.pageSize
  },
  sortOptions: state => {
    return state.sortOptions
  },
  getResource: (state, _, rootState) => ownerProfileId => {
    const resources = [
      rootState.currentAdvertiser.currentCreative,
      ...state.insertionOrders,
    ]
    return resources.find(r => r.ownerProfileId === ownerProfileId)
  },
}
